<body>
  <fuse-main [@.disabled]="animationsDisabled">
  </fuse-main>

  <div *ngIf="isShowingRouteLoadIndicator" class="router-load-indicator">
    Loading...
  </div>
</body>